<template>
  <div v-if="data" v-cloak>
    <Top />
    <div class="img-banner-odd" v-if="oddOrEven === 'odd'">
      <div class="img-banner-text-odd">
        <img class="img-fam img-fluid" src="@/assets/img/family.svg?data" alt="Bild på familj">
        <p class="p-bannertext" v-html="data.landingpage.bannertext"></p>
      </div>
    </div>
    <div class="img-banner-even" v-if="oddOrEven === 'even'">
      <div class="img-banner-text-even">
        <img class="img-fam img-fluid" src="@/assets/img/family.svg?data" alt="Bild på familj">
        <p class="p-bannertext" v-html="data.landingpage.bannertext"></p>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div id="col-middle" class="col-sm-7" :class="{ 'order-1': isPhoneMediaQuery }">
          <div class="d-card">
            <p v-html="data.landingpage.welcometext"></p>
            <hr class="hr-399bc8" />
            <p v-html="data.landingpage.abouttext"></p>
          </div>
          <hr class="hr-399bc8" />
          <div class="d-card" :class="{ 'order-5': isPhoneMediaQuery }">
            <div class="row">
              <div class="col-sm">
                <small>Illustration förekomst FH</small>
                <a href="/static/img/screening-funnel.732e82b.svg" title="Öppna förekomst av FH i ny flik" target="_blank">
                  <img src="@/assets/img/screening-funnel.svg?data" alt="Illustration förekomst av FH">
                </a>
              </div>
              <div class="col-sm">
                <small>Flödesschema för indexpatienter</small>
                <a href="/static/img/flowchart-index.1ceccfa.svg" title="Öppna flödesschema i ny flik" target="_blank">
                  <img src="@/assets/img/flowchart-index.svg?data" alt="Flödesschema index">
                </a>
                <small>Flödesschema för gennegativa patienter</small>
                <a href="/static/img/flowchart-scr.1c1149c.svg" title="Öppna flödesschema i ny flik" target="_blank">
                  <img src="@/assets/img/flowchart-scr.svg?data" alt="Flödesschema gennegativa">
                </a>
              </div>
              <div class="col-sm">
                <small>Flödesschema för kardiologpatienter</small>
                <a href="/static/img/flowchart-cardio.b2b8ea6.svg" title="Öppna flödesschema i ny flik" target="_blank">
                  <img src="@/assets/img/flowchart-cardio.svg?data" alt="Flödesschema kardiolog">
                </a>
              </div>
            </div>
          </div>
          <hr class="hr-399bc8" />
          <div :class="{ 'order-4': isPhoneMediaQuery }">
            <p class="p-scroll" v-html="data.landingpage.newstext"></p>
          </div>
          <hr class="hr-399bc8" />
          <div class="text-content" :class="{ 'order-3': isPhoneMediaQuery }">
            <p v-html="data.landingpage.linkstext"></p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-sm"></div>
        <div class="col-sm"></div>
      </div>
      <div class="clearfix"></div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-sm"></div>
        <div class="col-sm"></div>
      </div>
    </div>
    <Bottom />
  </div>
</template>

<script>
import Top from '../../src/components/Top'
import Bottom from '../../src/components/Bottom'
import { request } from '../plugins/datocms'
import $ from 'jquery'

export default {
  name: 'landingpage',
  components: {
    Top,
    Bottom
  },
  data () {
    return {
      data: null,
      isPhoneMediaQuery: false,
      isDev: process.env.NODE_ENV === 'dev'
    }
  },
  computed: {
    oddOrEven () {
      const rnd = Math.floor(Math.random() * 9) + 1
      return (rnd & 1) ? 'odd' : 'even'
    }
  },
  created () {
    window.addEventListener('resize', this.resizeHandler)
    const maxWidth = window.matchMedia('(max-width: 812px)')
    const minWidth = window.matchMedia('(min-width: 300px)')
    if (maxWidth.matches && minWidth.matches) {
      this.isPhoneMediaQuery = true
    } else {
      this.isPhoneMediaQuery = false
    }
  },
  destroyed () {
    window.removeEventListener('resize', this.resizeHandler)
  },
  methods: {
    resizeHandler () {
      const browserZoomLevel = Math.round(window.devicePixelRatio * 100)
      if (browserZoomLevel > 100) {
        $('.img-banner-text-odd, .img-banner-text-even').addClass('resized')
        if (browserZoomLevel >= 175) {
          $('.img-banner-text-odd, .img-banner-text-even').removeClass('resized')
          $('.img-banner-text-odd, .img-banner-text-even').hide()
          $('.img-logo').css('width', '22vw')
        }
      } else {
        $('.img-banner-text-odd, .img-banner-text-even').show()
        $('.img-banner-text-odd, .img-banner-text-even').removeClass('resized')
      }
    }
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          landingpage {
            welcometext
            newstext
            linkstext
            abouttext
            bannertext
          }
        }
      `
    })
    setTimeout(() => {
      if (this.isPhoneMediaQuery) {
        $('.td-no-phone').hide()
      }
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.resized {
  margin: 3% !important;
  font-size: 80%;
}
.resized > .img-fam {
  max-width: 40%;
}
#col-middle {
  margin-left: auto;
  margin-right: auto;
}
.container {
  margin-top: 4vh !important;
  max-width: 99%;
  word-wrap: break-word;
}
.m-top {
  margin-left: 35px;
  margin-top: 100px;
  position: absolute;
  width: 400px;
  z-index: 999;
}
.border {
  padding: 15px;
  margin-bottom: 15px;
}
.border-l-r {
  border-left: 1px solid rgba(0,0,0,.1);
  border-right: 1px solid rgba(0,0,0,.1);
}
.p-scroll {
  overflow-x: hidden;
  overflow-y: scroll;
  max-height: 600px;
  padding: 5px;
}
.hr-399bc8 {
  background-color: #399bc8;
  height: 1px;
  border: 0;
}
.d-card {
  padding: 15px 15px 15px 15px;
  background: #fff;
  margin: 20px 0 25px 0;
}
.img-banner-odd {
  background-image: url("../assets/img/jpgs/fhabian-frontpage--1.jpg");
  background-attachment: fixed;
  background-repeat: round;
  background-position: 11% calc(10% + 65px);
  width: 100%;
  height: 50vh;
  margin-top: 18vh;
}
.img-banner-text-odd {
  width: 20vw;
  z-index: 999;
  float: right;
  margin: calc(5% - 20px);
  word-break: break-word;
}
.img-banner-even {
  background-image: url("../assets/img/jpgs/fhabian-frontpage--2.jpg");
  background-attachment: fixed;
  background-repeat: round;
  background-position: left top;
  width: 100%;
  height: 50vh;
  margin-top: 18vh;
}
.img-banner-text-even {
  width: 20vw;
  z-index: 999;
  float: left;
  margin: calc(6% - 20px);
  word-break: break-word;
}
/* Breakpoint for ugliness */
@media only screen and (max-width: 955px) {
  .img-banner-text-odd, .img-banner-text-even {
    display: none;
  }
}
@media screen and (max-width: 1280px) {
  .img-fam {
    max-width: 40%;
  }
  .img-banner-odd, .img-banner-even {
    margin-top: 20vh;
    width: 100vw;
    height: 40vh;
    background-attachment: scroll;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
  }
  .img-banner-text-odd, .img-banner-text-even {
    margin: 5%;
    font-size: .55em;
  }
  .container {
    margin-top: 5vh !important;
    font-size: 90%;
  }
}
/* Portrait */
@media only screen
  and (min-device-width: 300px)
  and (max-device-width: 812px) {
  h2 {
    font-size: 10px;
  }
  .container {
    margin-top: 0 !important;
  }
  .p-bannertext {
    width: 30vw;
  }
  .img-banner-text-odd, .img-banner-text-even {
    display: none;
  }
  .img-banner-odd, .img-banner-even {
    margin-top: 20vh;
    width: 100vw;
    height: 25vh;
    background-attachment: scroll;
    background-size: cover;
    background-repeat: repeat;
    background-position: center center;
  }
  .p-scroll {
    max-height: 300px;
    border: 1px solid rgba(0,0,0,.1);
    padding: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LandingPage.vue